<template>
    <div class="wrapper-bg">
        <HeaderOther
            :setTitle="'ตั้งค่าความเป็นส่วนตัว'"
            :setHref="'profile'"
            :showLogo="true"
        />
        <div class="main-layout coffee-privacy">
            <div class="menu-container-privacy">
                <!--  -->
                <div
                    id="accept-markentting-btn"
                    class="menu"
                    @click="gotoPath('/mktoptionsetting')"
                >
                    <p>ยินยอมเพื่อวัตถุประสงค์ทางการตลาด</p>
                    <!-- <img
                        src="@/assets/profile/arrow-icon@2x.png"
                        alt="arrow-img"
                    /> -->
                    <img
                        src="@/assets/profile/arrow_white.svg"
                        alt="arrow-img"
                    />
                </div>
                <!--  -->
                <div
                    id="personal-information-btn"
                    class="menu"
                    v-if="isShowSelfOption"
                    @click="gotoPath('/requestdocument/forme')"
                >
                    <p>ขอรับสำเนาข้อมูลส่วนบุคคล</p>
                    <img
                        src="@/assets/profile/arrow_white.svg"
                        alt="arrow-img"
                    />
                </div>
                <!--  -->
                <div
                    id="personal-data-controller"
                    class="menu"
                    v-if="isShowOtherOption"
                    @click="gotoPath('/requestdocument/forother')"
                >
                    <p>ส่งสำเนาข้อมูลส่วนบุคคลให้ผู้ควบคุมข้อมูลอื่น</p>
                    <img
                        src="@/assets/profile/arrow_white.svg"
                        alt="arrow-img"
                    />
                </div>
                <!--  -->
            </div>
            <div class="box-footer-privacy">
                <p class="call-callcenter fs-14">
                    Other request please contact <br />
                    <span>call center </span>
                    <a href="tel:026451212" class="call-tel">02-6451212 </a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
//core
import BzbsCustom from "@/core/Custom/service/BzbsCustom.js";
//components
import HeaderOther from "@/components/Header/HeaderOther.vue";

export default {
    name: "PrivacySettings",
    components: { HeaderOther },
    data: function () {
        return {
            isLoaded: true,
            isShowSelfOption: true,
            isShowOtherOption: true,
        };
    },
    created: function () {
        this.getBlobCofig();
    },
    mounted: function () {},
    methods: {
        getBlobCofig() {
            const url =
                "/nestle/nescafe_streetcafe/custom/nescafe_streetcafe_content.json";
            return new Promise((resolve, reject) => {
                BzbsCustom.apiGetCustom(url)
                    .then((response) => {
                        // console.log(response);
                        this.isShowSelfOption = response.isShowSelfMktoption;
                        this.isShowOtherOption = response.isShowOtherMktoption;
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        gotoPath(path) {
            this.$router.push(path);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/module/Profile/style/profile.scss";
</style>
